import {Section} from "./Section";
import {Button, Col, FormCheck, FormControl, Row} from "react-bootstrap";
import {useCallback, useEffect, useMemo, useState} from "react";
import {ButtonBlank} from "../controls/ButtonBlank";
import {IoIosArrowDown} from "react-icons/io";
import {IoIosArrowUp} from "react-icons/io";
import Collapse from "react-bootstrap/Collapse";
import data from "bootstrap/js/src/dom/data";
import {useCSVDownloader} from "react-papaparse";
import PropTypes from "prop-types";


export function DataListView(props) {
    const {title, header, searchHeaders, dataArray, onOpenChange, onItemEditChange} = props;
    const [search, setSearch] = useState("");
    const searchHeadersWithBool = searchHeaders?.filter(sh => sh.isBool === true);
    const obj = useMemo(() => {
        let objReturn = {}
        searchHeadersWithBool?.forEach(item => {
            objReturn[item.fieldName] = `${item.default === 'both' ? '' : item.default}`;
        });
        return objReturn;
    }, []);
console.log(searchHeaders)
    const [searchExtra, setSearchExtra] = useState(obj ? obj : {});
    const [columnSort, setColumnSort] = useState('');
    const [sortDirection, setSortDirection] = useState(false);
    const dataFiltered = filter(dataArray ? dataArray : [], columnSort, sortDirection, search, searchExtra);
    return <Section className={"mt-2"}>
        <SearchBar title={title}
                   searchExtra={searchExtra}
                   onSearchExtraChange={setSearchExtra}
                   searchHeaders={searchHeaders}
                   dataFiltered={dataFiltered}
                   search={search}
                   onSearchChanged={setSearch}/>
        <HeaderSection dataFiltered={dataFiltered}
                       columnSort={columnSort}
                       onColumnSortChange={setColumnSort}
                       sortDirection={sortDirection}
                       onSortDirectionChange={setSortDirection}
                       header={header}/>
        <DataSection onOpenChange={onOpenChange}
                     onItemEditChange={onItemEditChange}
                     dataArray={dataFiltered}
                     header={header}/>
    </Section>
}

function SearchBar(props) {
    const {
        title, search, onSearchChanged, dataFiltered, searchHeaders, onSearchExtraChange, searchExtra
    } = props;
    const {CSVDownloader, Type} = useCSVDownloader();
console.log(searchExtra)
    const [open, setOpen] = useState(false);
    return <Section className={"mb-2"}>

        {title ? <Col xs={12} className={"text-start "}>
            <CSVDownloader type={Type.Link} filename={`${title}-export-${new Date().toLocaleDateString('nl-BE')}`}
                           bom={true}
                           data={dataFiltered ? [...dataFiltered].map(fd => {
                               const newData = {...fd}
                               delete newData.id
                               delete newData.secretarissen
                               delete newData.voorzitters
                               delete newData.penningsMeesters
                               delete newData.raadsLeden
                               return newData
                           }) : dataFiltered} config={{delimiter: ";"}}>Exporteer onderstaande
                lijst</CSVDownloader>

        </Col> : ''}
        <Col>
            <FormControl placeholder={"Zoek in lijst"} value={search} onChange={(e) => {
                onSearchChanged(e.target.value);

            }}/>
            <strong>{`Totaal gevonden: ${dataFiltered.length}`}</strong>
        </Col>

        <Col xs={'auto'} className={'text-end ms-2'}>
            <Button className={'btn-light '} onClick={() => setOpen(!open)}>
                <p className={'text-nowrap p-0 m-0'}>Meer opties<span></span>{!open ? <IoIosArrowDown/> :
                    <IoIosArrowUp/>}</p>
            </Button>
        </Col>
        <Collapse in={open}>
            <div id="expand search field">
                <Row className={'g-0'}>
                    {searchHeaders?.map(sh => <ExtraSearchField key={sh.title}
                                                                onSearchExtraChange={onSearchExtraChange}
                                                                searchExtra={searchExtra} searchHeader={sh}/>)}
                </Row>
            </div>
        </Collapse>
    </Section>
}

function ExtraSearchField(props) {
    const {searchHeader, searchExtra, onSearchExtraChange} = props;
    const searchExtraObject = {...searchExtra};
console.log(searchHeader)
    return <>{searchHeader.isBool ? <Col xs={4} className={'p-1'}>
        <Row className={'g-0 justify-content-start'}>
            <Col xs={'3'}><p>{searchHeader.title}</p></Col>
            <Col>Ja<FormCheck defaultChecked={searchHeader.default === 'true'} checked={searchExtraObject[searchHeader.fieldName] === 'true'} type={'radio'} value={'true'}
                              name={'radioBoolTrue'}
                              onChange={(e) => {
                                  searchExtraObject[searchHeader.fieldName] = e.target.value;
                                  console.log(searchExtraObject[searchHeader.fieldName])

                                  onSearchExtraChange(searchExtraObject);
                              }}/></Col>
            <Col>Nee<FormCheck defaultChecked={searchHeader.default}  checked={searchExtraObject[searchHeader.fieldName] === 'false'} type={'radio'} value={'false'}
                               name={'radioBoolFalse'}
                               onChange={(e) => {
                                   searchExtraObject[searchHeader.fieldName] = e.target.value;
                                   console.log(searchExtraObject[searchHeader.fieldName])

                                   onSearchExtraChange(searchExtraObject);
                               }}/></Col>
            <Col>Beide<FormCheck type={'radio'} value={''} defaultChecked={searchHeader.default === 'both'}  checked={searchExtraObject[searchHeader.fieldName] === ''}
                                 name={'radioBoolBoth'} onChange={(e) => {
                searchExtraObject[searchHeader.fieldName] = e.target.value;
                console.log(searchExtraObject[searchHeader.fieldName])
                onSearchExtraChange(searchExtraObject);
            }}/></Col>
        </Row>
    </Col> : <Col xs={4} className={'p-1'}>
        <Row className={'g-0 justify-content-start'}>
            <Col xs={'3'}><p>{searchHeader.title}</p></Col>
            <Col><FormControl value={searchExtra[searchHeader.fieldName]} onChange={(e) => {
                searchExtraObject[searchHeader.fieldName] = e.target.value;
                onSearchExtraChange(searchExtraObject);
            }}/></Col>
        </Row>
    </Col>}</>
}

function HeaderSection(props) {
    const {
        header, sortDirection, columnSort, onColumnSortChange, onSortDirectionChange, dataFiltered,
    } = props;

    return <Section>
        {header?.map((i, index) => <HeaderSectionCol key={index}
                                                     dataFiltered={dataFiltered} header={i}
                                                     columnSort={columnSort}
                                                     onColumnSortChange={onColumnSortChange}
                                                     sortDirection={sortDirection}
                                                     onSortDirectionChange={onSortDirectionChange}/>)}
    </Section>
}

function HeaderSectionCol(props) {
    const {
        header, columnSort, sortDirection, onColumnSortChange, onSortDirectionChange, dataFiltered,

    } = props;
    return <>{header.title === "email" || header.title === "Email" || header.title === "straat" || header.title === "Straat" || header.title === "Club naam" || header.title === "Club" ?
        <Col xs={2} className={'text-start border ps-2'}>
            <Row className={"g-0"}>
                <Col>
                    <p className={'text-break fw-bold'}>{header.title}</p>
                </Col>
                <HeaderSortButtons columnHeaderName={header}
                                   dataFiltered={dataFiltered} columnSort={columnSort}
                                   onColumnSortChange={onColumnSortChange} sortDirection={sortDirection}
                                   onSortDirectionChange={onSortDirectionChange}/>
            </Row>
        </Col> : <Col className={'text-start border ps-2'}>
            <Row className={"g-0"}>
                <Col>
                    <p className={'text-break fw-bold'}>{header.title}</p>
                </Col>
                <HeaderSortButtons columnHeaderName={header}
                                   dataFiltered={dataFiltered} columnSort={columnSort}
                                   onColumnSortChange={onColumnSortChange} sortDirection={sortDirection}
                                   onSortDirectionChange={onSortDirectionChange}/>
            </Row>
        </Col>}
    </>
}

function HeaderSortButtons(props) {
    const {
        columnHeaderName, columnSort, onColumnSortChange, sortDirection, onSortDirectionChange, dataFiltered,

    } = props

    return <Col xs={'auto'}>
        <Row className={"g-0 m-0 p-0"}>
            {columnSort === columnHeaderName.fieldName ?
                <ButtonBlank style={{borderRadius: '5px', backgroundColor: 'blue'}} onClick={() => {
                    if (!sortDirection) {
                        onColumnSortChange(columnHeaderName.fieldName);
                        onSortDirectionChange(!sortDirection);

                    } else {
                        onColumnSortChange('');
                        onSortDirectionChange(false);

                    }
                }}>
                    {sortDirection ? <IoIosArrowUp style={{color: 'white'}}/> :
                        <IoIosArrowDown style={{color: 'white'}}/>}
                </ButtonBlank> : <ButtonBlank onClick={() => {
                    onColumnSortChange(columnHeaderName.fieldName);

                }}>
                    <IoIosArrowDown/>
                </ButtonBlank>}
        </Row>
    </Col>
}

function DataSection(props) {
    const {dataArray, header, onOpenChange, onItemEditChange} = props

    return <Section>
        {dataArray?.map((item, index) => <DataSectionRow onItemEditChange={onItemEditChange} onOpenChange={onOpenChange}
                                                         key={index} header={header} index={index} item={item}/>)}
    </Section>

}

function DataSectionRow(props) {
    const {item, index, header, onOpenChange, onItemEditChange} = props;
    const styleDefault = {
        backGroundColorEven: {backgroundColor: 'ghostwhite'}, backGroundColorUneven: {backgroundColor: 'white'}
    }
    const [style, setStyle] = useState(styleDefault)

    const styleHover = {
        backGroundColorEven: {backgroundColor: '#e9e9f5'}, backGroundColorUneven: {backgroundColor: '#e9e9f5'}
    }

    return <button onClick={() => {

        if (onItemEditChange) onItemEditChange(item);
        if (onOpenChange) onOpenChange(true);
    }} className={'border-0 p-0'}>
        <Row onMouseOver={() => setStyle(styleHover)} onMouseLeave={() => setStyle(styleDefault)}
             style={index % 2 == 0 ? style.backGroundColorEven : style.backGroundColorUneven}
             className={'g-0'}>{header?.map((itemHeader, indexHeader) => <DataSectionCol key={indexHeader * 1000}
                                                                                         bigCol={itemHeader.fieldName === "email" || itemHeader.fieldName === "Email" || itemHeader.fieldName === "adres1" || itemHeader.fieldName === "Adres" || itemHeader.fieldName === "clubNaam"}
                                                                                         data={item[itemHeader.fieldName]}/>)}</Row>
    </button>
}

function DataSectionCol(props) {
    const {data, bigCol} = props;

    return <>
        {bigCol ? <Col xs={2} className={'text-start border-bottom border-start border-end ps-1'}>
            <p style={{fontSize: "14px"}} className={"m-0"}>{data}</p>
        </Col> : <Col className={'text-start border-bottom border-start border-end ps-1'}>
            <p style={{fontSize: "14px"}} className={"m-0"}>{data}</p>
        </Col>}
    </>
}

function sortArray(array, columnSort, sortDirection) {
    if (columnSort === 'lidNr' || columnSort === 'stamNummer' || columnSort === 'memberNumber') {
        if (sortDirection) {
            return [...array].sort((a1, a2) => a1[columnSort] - a2[columnSort]);
        } else {
            return [...array].sort((a1, a2) => a2[columnSort] - a1[columnSort]);
        }
    } else {
        if (sortDirection) {
            return [...array].sort((m1, m2) => ('' + m1[columnSort]).localeCompare('' + m2[columnSort]))
        } else {
            return [...array].sort((m1, m2) => ('' + m2[columnSort]).localeCompare('' + m1[columnSort]))
        }
    }
}

function filter(dataArray, columnSort, sortDirection, search, searchExtra) {

    let filteredArray = [...dataArray];
    if (search === '') {
        if (columnSort === '') {
            filteredArray = dataArray;
        }
        if (columnSort !== '') {
            filteredArray = sortArray([...dataArray], columnSort, sortDirection)
        }
    } else {
        if (columnSort === '') {
            filteredArray = [...dataArray].filter((data, dataIndex) => (Object.keys(data)?.filter(key => data[key]?.toString().toLowerCase()?.includes(search.toLowerCase()))).length > 0)
        } else {
            if (sortDirection) {
                filteredArray = sortArray([...dataArray].filter((data, dataIndex) => (Object.keys(data)?.filter(key => data[key]?.toString().toLowerCase()?.includes(search.toLowerCase()))).length > 0), columnSort, sortDirection);
            } else {
                filteredArray = sortArray([...dataArray].filter((data, dataIndex) => (Object.keys(data)?.filter(key => data[key]?.toString().toLowerCase()?.includes(search.toLowerCase()))).length > 0), columnSort, sortDirection);
            }
        }

    }

    let filteredExtraArray = [...filteredArray];
    Object.keys(searchExtra).forEach(key => {
        if (searchExtra[key] !== '') {
            filteredExtraArray = [...filteredExtraArray]?.filter(m => m[key]?.toString().toLowerCase()?.includes(searchExtra[key].toLowerCase()));
        }
    })

    return filteredExtraArray;
}

DataListView.propTypes = {
    title: PropTypes.string,
    header: PropTypes.array,
    searchHeaders: PropTypes.array,
    dataArray: PropTypes.array,
    onOpenChange: PropTypes.func,
    onItemEditChange: PropTypes.func
}